import { MeshApolloProvider } from '@agilelab/plugin-wb-platform';
import {
  ALL_TAXONOMIES_FILTER,
  useTaxonomySelection,
} from '@agilelab/plugin-wb-practice-shaper';
import { configApiRef, useApi } from '@mainstage/core-plugin-api';
import { Box, useTheme } from '@material-ui/core';
import { Navigate } from 'react-router';
import { HistoricalDataCard } from './HistoricalDataCard';
import { RealTimeDataCard } from './RealTimeDataCard';
import { parseOptionalBooleanConfig } from './utils';

export const MeshSupervisionPage = () => {
  const configApi = useApi(configApiRef);
  const theme = useTheme();
  const animationsDuration = 500;

  const enabledMeshSupervision = parseOptionalBooleanConfig(
    configApi.getOptionalBoolean(
      'mesh.marketplace.ui.meshSupervisionPage.enabled',
    ),
  );

  const { selectedTaxonomyRef } = useTaxonomySelection();

  if (!enabledMeshSupervision) return <Navigate to="/" />;
  return (
    <MeshApolloProvider>
      <Box
        display="flex"
        flexDirection="column"
        style={{ gap: theme.spacing(2) }}
      >
        <RealTimeDataCard animationsDuration={animationsDuration} />
        {selectedTaxonomyRef !== ALL_TAXONOMIES_FILTER && (
          <HistoricalDataCard animationsDuration={animationsDuration} />
        )}
      </Box>
    </MeshApolloProvider>
  );
};
